import { render, staticRenderFns } from "./ClinicianReportInfo.vue?vue&type=template&id=60d321a0&scoped=true&"
import script from "./ClinicianReportInfo.vue?vue&type=script&lang=js&"
export * from "./ClinicianReportInfo.vue?vue&type=script&lang=js&"
import style0 from "./ClinicianReportInfo.vue?vue&type=style&index=0&id=60d321a0&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "60d321a0",
  null
  
)

export default component.exports